export const EpicFhirAuthModeLabelMap = {
    'cert': 'Cert / Secret Manager (legacy)',
    'jwks': 'JWKS / KMS',
};
//# sourceMappingURL=consts.js.map